/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import DictionaryList from "@/components/pages/dictionary/DictionaryList/index.vue";
import DictionaryListTokens from "@/components/pages/dictionary/DictionaryList/Tokens.vue";
import Dictionary from "@/components/pages/dictionary/Dictionary/index.vue";
import Dictionary_DataComponentModelList from "@/components/pages/dictionary/Dictionary/DataComponentModelList.vue";
import Dictionary_ServiceComponentModelList from "@/components/pages/dictionary/Dictionary/ServiceComponentModelList.vue";
import Dictionary_CategoryList from "@/components/pages/dictionary/Dictionary/CategoryList.vue";
import DataComponentModel from "@/components/pages/dictionary/DataComponentModel/index.vue";
import DataComponentModel_DataPropertyDefinitionList from "@/components/pages/dictionary/DataComponentModel/DataPropertyDefinitionList.vue";
import DataComponentModel_DataRelationList from "@/components/pages/dictionary/DataComponentModel/DataRelationList.vue";
import DataComponentModel_ExtendedDataPropertyDefinition from "@/components/pages/dictionary/DataComponentModel/ExtendedDataPropertyDefinition.vue";
import DataComponentModel_ProcessOperationList from "@/components/pages/dictionary/DataComponentModel/ProcessOperationList.vue";
import ServiceComponentModel from "@/components/pages/dictionary/ServiceComponentModel/index.vue";
import ServiceComponentModel_ProcessComponentModelList from "@/components/pages/dictionary/ServiceComponentModel/ProcessComponentModelList.vue";
import ServiceComponentModel_ProcessOperationList from "@/components/pages/dictionary/ServiceComponentModel/ProcessOperationList.vue";

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * 辞書管理
   ********************************************************************************************************************/

  // 辞書一覧 ----------------------------------------------------------------------------------------------------------
  // 共通辞書
  {
    path: '/browse/common/dictionary',
    name: '/browse/common/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '共通辞書一覧',
      parent: 'Home',
    }
  }, {
    path: '/edit/common/dictionary',
    name: '/edit/common/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '共通辞書一覧',
      parent: 'Home',
      permissions: ['dictionary', 'platformOwner'],
      fallback: '/browse/common/dictionary/DictionaryList',
    }
  },
  // 個別辞書
  {
    path: '/browse/local/dictionary',
    name: '/browse/local/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '個別辞書一覧',
      parent: 'Home',
    }
  }, {
    path: '/edit/local/dictionary',
    name: '/edit/local/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '個別辞書一覧',
      parent: 'Home',
      permissions: ['dictionary'],
      fallback: '/browse/local/dictionary/DictionaryList',
    }
  },
  // 外部辞書
  {
    path: '/browse/external/dictionary',
    name: '/browse/external/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '外部辞書一覧',
      parent: 'Home',
    }
  }, {
    path: '/edit/external/dictionary',
    name: '/edit/external/dictionary/DictionaryList',
    component: DictionaryList,
    meta: {
      label: '外部辞書一覧',
      parent: 'Home',
      permissions: ['dictionary'],
      fallback: '/browse/external/dictionary/DictionaryList',
    }
  },
  // 外部辞書トークン一覧
  {
    path: '/edit/tokens/dictionary',
    name: '/edit/tokens/dictionary/DictionaryList',
    component: DictionaryListTokens,
    meta: {
      label: '外部辞書トークン一覧',
      parent: '/edit/external/dictionary/DictionaryList',
      permissions: ['dictionary'],
    }
  },

  // 辞書一覧 / 辞書閲覧・編集 -----------------------------------------------------------------------------------------
  // 共通辞書
  {
    path: '/browse/common/dictionary/:dictionaryId',
    name: '/browse/common/dictionary/Dictionary',
    component: Dictionary,
    props: true,
    meta: {
      label: '共通辞書閲覧',
      parent: '/browse/common/dictionary/DictionaryList',
    },
    children: [{
      path: 'datas',
      name: '/browse/common/dictionary/Dictionary/datas',
      component: Dictionary_DataComponentModelList
    }, {
      path: 'services',
      name: '/browse/common/dictionary/Dictionary/services',
      component: Dictionary_ServiceComponentModelList
    }, {
      path: 'categories',
      name: '/browse/common/dictionary/Dictionary/categories',
      component: Dictionary_CategoryList
    }]
  }, {
    path: '/edit/common/dictionary/:dictionaryId',
    name: '/edit/common/dictionary/Dictionary',
    component: Dictionary,
    props: true,
    meta: {
      label: '共通辞書編集',
      parent: '/edit/common/dictionary/DictionaryList',
      permissions: ['dictionary', 'platformOwner'],
      fallback: '/browse/common/dictionary/Dictionary',
    },
    children: [{
      path: 'datas',
      name: '/edit/common/dictionary/Dictionary/datas',
      component: Dictionary_DataComponentModelList
    }, {
      path: 'services',
      name: '/edit/common/dictionary/Dictionary/services',
      component: Dictionary_ServiceComponentModelList
    }, {
      path: 'categories',
      name: '/edit/common/dictionary/Dictionary/categories',
      component: Dictionary_CategoryList
    }]
  },
  // 個別辞書
  {
    path: '/browse/local/dictionary/:dictionaryId',
    name: '/browse/local/dictionary/Dictionary',
    component: Dictionary,
    props: true,
    meta: {
      label: '個別辞書閲覧',
      parent: '/browse/local/dictionary/DictionaryList',
    },
    children: [{
      path: 'datas',
      name: '/browse/local/dictionary/Dictionary/datas',
      component: Dictionary_DataComponentModelList
    }, {
      path: 'services',
      name: '/browse/local/dictionary/Dictionary/services',
      component: Dictionary_ServiceComponentModelList
    }]
  }, {
    path: '/edit/local/dictionary/:dictionaryId',
    name: '/edit/local/dictionary/Dictionary',
    component: Dictionary,
    props: true,
    meta: {
      label: '個別辞書編集',
      parent: '/edit/local/dictionary/DictionaryList',
      permissions: ['dictionary'],
      fallback: '/browse/local/dictionary/Dictionary',
    },
    children: [{
      path: 'datas',
      name: '/edit/local/dictionary/Dictionary/datas',
      component: Dictionary_DataComponentModelList
    }, {
      path: 'services',
      name: '/edit/local/dictionary/Dictionary/services',
      component: Dictionary_ServiceComponentModelList
    }]
  },
  // 外部辞書
  {
    path: '/browse/external/dictionary/:dictionaryId',
    name: '/browse/external/dictionary/Dictionary',
    component: Dictionary,
    props: true,
    meta: {
      label: '外部辞書閲覧',
      parent: '/browse/external/dictionary/DictionaryList',
    },
    children: [{
      path: 'datas',
      name: '/browse/external/dictionary/Dictionary/datas',
      component: Dictionary_DataComponentModelList
    }, {
      path: 'services',
      name: '/browse/external/dictionary/Dictionary/services',
      component: Dictionary_ServiceComponentModelList
    }]
  },

  // 辞書一覧 / 辞書閲覧・編集 / サービス構成モデル --------------------------------------------------------------------
  // 共通辞書
  {
    path: '/browse/common/dictionary/:dictionaryId/service/:serviceComponentModelId',
    name: '/browse/common/dictionary/ServiceComponentModel',
    component: ServiceComponentModel,
    props: true,
    meta: {
      label: 'サービス構成モデル閲覧',
      parent: '/browse/common/dictionary/Dictionary/services',
    },
    children: [{
      path: 'processComponentModels',
      name: '/browse/common/dictionary/ServiceComponentModel/processComponentModels',
      component: ServiceComponentModel_ProcessComponentModelList
    }, {
      path: 'processOperations',
      name: '/browse/common/dictionary/ServiceComponentModel/processOperations',
      component: ServiceComponentModel_ProcessOperationList
    }]
  }, {
    path: '/edit/common/dictionary/:dictionaryId/service/:serviceComponentModelId',
    name: '/edit/common/dictionary/ServiceComponentModel',
    component: ServiceComponentModel,
    props: true,
    meta: {
      label: 'サービス構成モデル編集',
      parent: '/edit/common/dictionary/Dictionary/services',
      permissions: ['dictionary', 'platformOwner'],
      fallback: '/browse/common/dictionary/ServiceComponentModel',
    },
    children: [{
      path: 'processComponentModels',
      name: '/edit/common/dictionary/ServiceComponentModel/processComponentModels',
      component: ServiceComponentModel_ProcessComponentModelList
    }, {
      path: 'processOperations',
      name: '/edit/common/dictionary/ServiceComponentModel/processOperations',
      component: ServiceComponentModel_ProcessOperationList
    }]
  },
  // 個別辞書
  {
    path: '/browse/local/dictionary/:dictionaryId/service/:serviceComponentModelId',
    name: '/browse/local/dictionary/ServiceComponentModel',
    component: ServiceComponentModel,
    props: true,
    meta: {
      label: 'サービス構成モデル閲覧',
      parent: '/browse/local/dictionary/Dictionary/services',
    },
    children: [{
      path: 'processComponentModels',
      name: '/browse/local/dictionary/ServiceComponentModel/processComponentModels',
      component: ServiceComponentModel_ProcessComponentModelList
    }, {
      path: 'processOperations',
      name: '/browse/local/dictionary/ServiceComponentModel/processOperations',
      component: ServiceComponentModel_ProcessOperationList
    }]
  }, {
    path: '/edit/local/dictionary/:dictionaryId/service/:serviceComponentModelId',
    name: '/edit/local/dictionary/ServiceComponentModel',
    component: ServiceComponentModel,
    props: true,
    meta: {
      label: 'サービス構成モデル編集',
      parent: '/edit/local/dictionary/Dictionary/services',
      permissions: ['dictionary'],
      fallback: '/browse/local/dictionary/ServiceComponentModel',
    },
    children: [{
      path: 'processComponentModels',
      name: '/edit/local/dictionary/ServiceComponentModel/processComponentModels',
      component: ServiceComponentModel_ProcessComponentModelList
    }, {
      path: 'processOperations',
      name: '/edit/local/dictionary/ServiceComponentModel/processOperations',
      component: ServiceComponentModel_ProcessOperationList
    }]
  },
  // 外部辞書
  {
    path: '/browse/external/dictionary/:dictionaryId/service/:serviceComponentModelId',
    name: '/browse/external/dictionary/ServiceComponentModel',
    component: ServiceComponentModel,
    props: true,
    meta: {
      label: 'サービス構成モデル閲覧',
      parent: '/browse/external/dictionary/Dictionary/services',
    },
    children: [{
      path: 'processComponentModels',
      name: '/browse/external/dictionary/ServiceComponentModel/processComponentModels',
      component: ServiceComponentModel_ProcessComponentModelList
    }, {
      path: 'processOperations',
      name: '/browse/external/dictionary/ServiceComponentModel/processOperations',
      component: ServiceComponentModel_ProcessOperationList
    }]
  },


  // 辞書一覧 / 辞書閲覧・編集 / データ構成モデル ----------------------------------------------------------------------
  // 共通辞書
  {
    path: '/browse/common/dictionary/:dictionaryId/data/:dataComponentModelId',
    name: '/browse/common/dictionary/DataComponentModel',
    component: DataComponentModel,
    props: true,
    meta: {
      label: 'データ構成モデル閲覧',
      parent: '/browse/common/dictionary/Dictionary/datas',
    },
    children: [{
      path: 'dataPropertyDefinitions',
      name: '/browse/common/dictionary/DataComponentModel/dataPropertyDefinitions',
      component: DataComponentModel_DataPropertyDefinitionList
    }, {
      path: 'dataRelationModels',
      name: '/browse/common/dictionary/DataComponentModel/dataRelationModels',
      component: DataComponentModel_DataRelationList
    }, {
      path: 'processOperations',
      name: '/browse/common/dictionary/DataComponentModel/processOperations',
      component: DataComponentModel_ProcessOperationList
    }]
  }, {
    path: '/edit/common/dictionary/:dictionaryId/data/:dataComponentModelId',
    name: '/edit/common/dictionary/DataComponentModel',
    component: DataComponentModel,
    props: true,
    meta: {
      label: 'データ構成モデル編集',
      parent: '/edit/common/dictionary/Dictionary/datas',
      permissions: ['dictionary', 'platformOwner'],
      fallback: '/browse/common/dictionary/DataComponentModel',
    },
    children: [{
      path: 'dataPropertyDefinitions',
      name: '/edit/common/dictionary/DataComponentModel/dataPropertyDefinitions',
      component: DataComponentModel_DataPropertyDefinitionList
    }, {
      path: 'dataRelationModels',
      name: '/edit/common/dictionary/DataComponentModel/dataRelationModels',
      component: DataComponentModel_DataRelationList
    }, {
      path: 'processOperations',
      name: '/edit/common/dictionary/DataComponentModel/processOperations',
      component: DataComponentModel_ProcessOperationList
    }]
  },
  // 個別辞書
  {
    path: '/browse/local/dictionary/:dictionaryId/data/:dataComponentModelId',
    name: '/browse/local/dictionary/DataComponentModel',
    component: DataComponentModel,
    props: true,
    meta: {
      label: 'データ構成モデル閲覧',
      parent: '/browse/local/dictionary/Dictionary/datas',
    },
    children: [{
      path: 'dataPropertyDefinitions',
      name: '/browse/local/dictionary/DataComponentModel/dataPropertyDefinitions',
      component: DataComponentModel_DataPropertyDefinitionList
    }, {
      path: 'extendedDataPropertyDefinitions',
      name: '/browse/local/dictionary/DataComponentModel/extendedDataPropertyDefinitions',
      component: DataComponentModel_ExtendedDataPropertyDefinition
    }, {
      path: 'processOperations',
      name: '/browse/local/dictionary/DataComponentModel/processOperations',
      component: DataComponentModel_ProcessOperationList
    }]
  }, {
    path: '/edit/local/dictionary/:dictionaryId/data/:dataComponentModelId',
    name: '/edit/local/dictionary/DataComponentModel',
    component: DataComponentModel,
    props: true,
    meta: {
      label: 'データ構成モデル編集',
      parent: '/edit/local/dictionary/Dictionary/datas',
      permissions: ['dictionary'],
      fallback: '/browse/local/dictionary/DataComponentModel',
    },
    children: [{
      path: 'dataPropertyDefinitions',
      name: '/edit/local/dictionary/DataComponentModel/dataPropertyDefinitions',
      component: DataComponentModel_DataPropertyDefinitionList
    }, {
      path: 'extendedDataPropertyDefinitions',
      name: '/edit/local/dictionary/DataComponentModel/extendedDataPropertyDefinitions',
      component: DataComponentModel_ExtendedDataPropertyDefinition
    }, {
      path: 'processOperations',
      name: '/edit/local/dictionary/DataComponentModel/processOperations',
      component: DataComponentModel_ProcessOperationList
    }]
  },
  // 外部辞書
  {
    path: '/browse/external/dictionary/:dictionaryId/data/:dataComponentModelId',
    name: '/browse/external/dictionary/DataComponentModel',
    component: DataComponentModel,
    props: true,
    meta: {
      label: 'データ構成モデル閲覧',
      parent: '/browse/external/dictionary/Dictionary/datas',
    },
    children: [{
      path: 'dataPropertyDefinitions',
      name: '/browse/external/dictionary/DataComponentModel/dataPropertyDefinitions',
      component: DataComponentModel_DataPropertyDefinitionList
    }, {
      path: 'extendedDataPropertyDefinitions',
      name: '/browse/external/dictionary/DataComponentModel/extendedDataPropertyDefinitions',
      component: DataComponentModel_ExtendedDataPropertyDefinition
    }, {
      path: 'processOperations',
      name: '/browse/external/dictionary/DataComponentModel/processOperations',
      component: DataComponentModel_ProcessOperationList
    }]
  },
];

export default routes;
